var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css, nothing } from "lit";
import { customElement, PICBase, stringDecoder, PICWebSocketClient, PIC, exportFetchURL, doSubmit, booleanDecoder, PICAction, PICLoadPage } from "../Internals";
import { property, state } from "lit/decorators.js";
import { classMap } from 'lit/directives/class-map.js';
let PICLoad = class PICLoad extends PICBase {
    constructor() {
        super();
        this.blockUserInteraction = false;
        this.allowMinimize = false;
        this.minimize = false;
        this.buttonWidth = 142;
        this.isLoading_ = true;
        this.isinput__ = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.socketChannel_) {
            let sessionCode = PIC.sessionCode;
            //TODO: find active layer
            let modal = document.querySelector('pic-loadpage');
            if (modal && modal.isVisible && modal.selfSessId) {
                sessionCode = modal.selfSessId;
            }
            this.socketChannel_ = new PICWebSocketClient({ host: exportFetchURL({ path: 'wss' }), port: '', channelId: this.channelId_, sessionCode: sessionCode, systemId: PIC.systemId, managedByPic: false });
            this.socketChannel_.addSocketEventListener('message', this.parseMessage_.bind(this));
            this.socketChannel_.addSocketEventListener('close', this.handleClose_.bind(this));
        }
        this.addEventListener('clear', this.handleCMDClear);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('clear', this.handleCMDClear);
    }
    static get styles() {
        const defaultStyle = css `
            :host {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .loadContainer{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                width: 35%;
                min-width: 250px;
                max-width: 400px;
                box-sizing: border-box;
            }        
            .center {
                position: fixed;
                z-index: 9999999;
                top: 30%;
                left: 50%;
                transform: translate(-50%, -50%);
                padding: 20px;
                border: 1px solid var(--pic-outline, #000);
                background-color: var(--pic-surfaceColor, white);
                box-shadow: 
                    0px 24px 38px rgba(0, 0, 0, 0.14), 
                    0px 9px 46px rgba(0, 0, 0, 0.12), 
                    0px 11px 15px rgba(0, 0, 0, 0.2);
            }
            
            .pic-loadingicon{
                width: 10em;
                height: 10em;
                margin-bottom: 15px;
                background-color: transparent;
                background-size: contain;
            }
            span {
                font-family: monospace;
                word-break: break-all;
                /* Explicit rather than inherited - this span can sit directly
                   on the page (no .center box), so it can't rely on picking
                   up a themed color from an ancestor. */
                color: var(--pic-onSurfaceHighColor, black);
            }
            .overlay {
                width: 100%;
                height: 100%;
                position: fixed;
                background-color: rgba(0, 0, 0, .4);
                z-index: 9999998;
                top: 0;
                left: 0;
                opacity: 0.4;
            }
            .overlayBtn {
                margin: 18px auto 0;
                width: auto !important;
                max-width: none !important;
            }
            .minimizeContainer {
                height: 80%;
                width: auto;
            }
            .smallLoadingIcon {
                height: 2.5em;
                width: 2.5em;
                margin-bottom: 0;
                opacity: 0.8;
            }
            .hide {
                display: none;
            }
            .minimizeContainer span {
                display: none;
            }
            .tooltip {
                background-color: white;
                color: black;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    //Clear command in this case, just removes entire loader.
    handleCMDClear(event) {
        this.socketChannel_.closeSocket();
        this.remove();
    }
    handleClose_(event) {
        this.isLoading_ = false;
        this.requestUpdate();
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        if (this.initMsg_) {
            this.handleMessage_(this.initMsg_);
        }
    }
    parseMessage_(event) {
        if (event.data)
            this.handleMessage_(event.data);
    }
    handleMessage_(iData) {
        var _a, _b;
        if (iData) {
            try {
                let dataArr = JSON.parse(iData);
                let msg = dataArr[0];
                if (msg.type == 'progress') {
                    try {
                        const txt = atob(msg.data);
                        this.text_ = txt;
                    }
                    catch (err) {
                        this.text_ = msg.data;
                    }
                    this.requestUpdate();
                }
                else if (msg.type == 'done') {
                    let event = 'refresh';
                    try {
                        event = (_a = atob(msg.data)) !== null && _a !== void 0 ? _a : 'refresh';
                    }
                    catch (err) {
                        event = (_b = msg.data) !== null && _b !== void 0 ? _b : 'refresh';
                    }
                    //If Loadpage is available and active, fire in that window instead
                    let modal = PIC.getInstance.events.activeModal;
                    if (!modal)
                        modal = document.querySelector('pic-loadpage');
                    if (modal && modal instanceof PICLoadPage && modal.isVisible) {
                        modal.handleSubmit(event, null);
                    }
                    else {
                        doSubmit(event);
                    }
                }
            }
            catch (error) {
            }
        }
    }
    getLoadClass() {
        return {
            'pic-loadingicon': this.isLoading_,
            'smallLoadingIcon': this.minimize === true
        };
    }
    getBtnClass() {
        return {
            'overlayBtn': true,
            'hide': this.minimize
        };
    }
    getLoadContainerClass() {
        return {
            'loadContainer': true,
            'center': this.blockUserInteraction === true && !this.minimize,
            'minimizeContainer': this.minimize === true,
        };
    }
    getOverlayClass() {
        return {
            'overlay': true,
        };
    }
    handleHideOverlay() {
        this.blockUserInteraction = false;
    }
    handleMinimizeOverlay(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.minimize = true;
        this.blockUserInteraction = false;
        let load = this;
        let headerBox = document.querySelector('header .header-right');
        if (headerBox)
            headerBox.appendChild(load);
    }
    hideOverlay() {
        // new PICAction -> small hack -> else btn submits blank event
        return html `
            <pic-button 
                .action=${new PICAction()} 
                @click=${this.handleMinimizeOverlay}
                class=${classMap(this.getBtnClass())}
                etype='contained' 
                type='button' 
                density='low'
                label='Minimize'>
            </pic-button>
        `;
    }
    render() {
        var _a;
        let miniHostStyle = `:host { height: 100%; }`;
        return html ` 
            ${this.renderCSS(true)}
            <style>${this.minimize ? html `${miniHostStyle}` : nothing}</style>
            <div class=${classMap(this.getLoadContainerClass())}>
                <div class=${classMap(this.getLoadClass())}>
                </div>
                <span>${(_a = this.text_) !== null && _a !== void 0 ? _a : 'Loading'}</span>
                ${this.blockUserInteraction && this.allowMinimize ? this.hideOverlay() : ''}
            </div>
            ${this.blockUserInteraction ? html `<div class=${classMap(this.getOverlayClass())}></div>` : ''}
            ${this.minimize ? html `<pic-tooltip>${this.text_.replace(/<br>|<br\/>/gm, '\n')}</pic-tooltip>` : ''}
            `;
    }
    ;
};
__decorate([
    property({ reflect: true, attribute: 'text', converter: stringDecoder })
], PICLoad.prototype, "text_", void 0);
__decorate([
    property({ reflect: true, attribute: 'channelid', converter: stringDecoder })
], PICLoad.prototype, "channelId_", void 0);
__decorate([
    property({ reflect: true, attribute: 'initialmsg', converter: stringDecoder })
], PICLoad.prototype, "initMsg_", void 0);
__decorate([
    property({ attribute: 'blockuserinteraction', converter: booleanDecoder })
], PICLoad.prototype, "blockUserInteraction", void 0);
__decorate([
    property({ attribute: 'allowminimize', converter: booleanDecoder })
], PICLoad.prototype, "allowMinimize", void 0);
__decorate([
    state()
], PICLoad.prototype, "minimize", void 0);
PICLoad = __decorate([
    customElement('pic-load')
], PICLoad);
export { PICLoad };
//# sourceMappingURL=PICLoad.js.map